var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.demanda !== '')?_c('div',{staticClass:"dem-dev-nova"},[_c('App-Demanda-Gerenciar',{attrs:{"cpntDemanda":_vm.demanda,"cpntSelecionar":_vm.demDevSelecionarDemanda}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }